import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';
import { apiCall } from '../services/api.service';
import LoadingSkeleton from '../components/LoadingSkeleton';

const AwaitPaymentsPage = () => {
  const { user, token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAwaitingPayments = async () => {
      if (!user?.id || !token) return;

      try {
        const result = await apiCall('post', 'v1/orders/awaiting-payment', { user_id: user.id }, token);
        if (result.success) {
          setOrders(result.data || []);
        } else {
          setError(result.message || 'Failed to load orders');
        }
      } catch (err) {
        console.error('Error fetching awaiting payments:', err);
        setError('An error occurred while loading orders');
      } finally {
        setLoading(false);
      }
    };

    fetchAwaitingPayments();
  }, [user, token]);

  if (loading) {
    return (
      <>
        <Header />
        <main className="main__content_wrapper">
          <div className="container py-5">
            <div className="row">
              <div className="col-12">
                <h1 className="mb-4">Awaiting Payment Confirmation</h1>
                <div className="row">
                  <LoadingSkeleton type="order" count={6} />
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <main className="main__content_wrapper">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h1 className="mb-4">Awaiting Payment Confirmation</h1>
              
              {error && (
                <div className="alert alert-danger">{error}</div>
              )}
              
              {orders.length === 0 && !error ? (
                <div className="text-center py-5">
                  <h3>No orders awaiting payment</h3>
                  <p>All your orders have been processed.</p>
                  <Link to="/shop" className="btn btn-primary">Continue Shopping</Link>
                </div>
              ) : (
                <div className="row">
                  {orders.map((order) => (
                    <div key={order.id} className="col-md-6 col-lg-4 mb-4">
                      <div className="card h-100">
                        <div className="card-body">
                          <h5 className="card-title">Order #{order.id}</h5>
                          <p className="card-text">
                            <strong>Total:</strong> ${order.grand_total}<br/>
                            <strong>Date:</strong> {new Date(order.date_time).toLocaleDateString()}<br/>
                            <strong>Status:</strong> <span className="badge bg-warning">Awaiting Payment</span>
                          </p>
                          <div className="d-flex gap-2">
                            <button className="btn btn-primary btn-sm">Complete Payment</button>
                            <Link to={`/order/${order.id}`} className="btn btn-outline-primary btn-sm">View Details</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AwaitPaymentsPage;